<template>
  <div class="shareIcon">
    <font-awesome-icon :icon="['fab', icon]" />
    </div>
  </div>
</template>

<script>
 export default {
   name: 'ShareIcon',
   props: ['icon', 'inputStyle'],
   data () {
     return {
       panel: false
     }
   },
   methods: {
     setPanel (t) {
       console.log('set panel', t)
       this.panel =t
     }
     
   },
   computed: {
    
   },
   component: {
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .panel{
   
   display: none;
   background-color: rgba(255,255,255, 0.2);
   border-radius: 8px;
   width: 7vw;
   height: 6vw;
 }

 .shareIcon:hover {
   cursor: pointer;
 }
 .panel.display{
   display: flex !important;
 }
</style>
